
(() => {
  const announcement = document.querySelector('.announcement-bar');
  const message = announcement?.querySelector('.announcement-bar__text');
  if (announcement && message && !announcement.querySelector('.bevanup-announcement-track')) {
    const label = message.textContent.trim();
    const track = document.createElement('div');
    track.className = 'bevanup-announcement-track';
    for (let index = 0; index < 8; index += 1) {
      const item = document.createElement('span');
      item.className = 'bevanup-announcement-item';
      item.textContent = label;
      track.appendChild(item);
    }
    message.replaceWith(track);
  }
  const intro = document.querySelector('[data-bevanup-intro]');
  if (!intro) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    intro.classList.add('is-leaving');
    window.setTimeout(() => intro.remove(), reduceMotion ? 1 : 420);
  };
  requestAnimationFrame(() => intro.classList.add('is-revealed'));
  const handoff = window.setTimeout(() => intro.classList.add('is-handoff'), reduceMotion ? 1 : 1180);
  const timer = window.setTimeout(finish, reduceMotion ? 1 : 1660);
  intro.addEventListener('click', () => { window.clearTimeout(handoff); window.clearTimeout(timer); finish(); }, { once: true });
  intro.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
      window.clearTimeout(handoff);
      window.clearTimeout(timer);
      finish();
    }
  });
})();
